import t from 'typy';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Field, connect } from 'formik';

import CheckIcon from '../../img/icons/Check';

import './bbCheckbox.scss';

//use for any formik forms
class BbFormikCheckbox extends React.Component {

    render() {
        const labelClass = this.props.labelClass;
        return (
            <div className={`bb-chk-grp`} style={this.props.style}>
                {this.props.label && <label onClick={() => document.getElementById(this.props.id).click()}
                    className={classnames("input-label", labelClass ? { [labelClass]: true } : {})}
                >
                    {ReactHtmlParser(this.props.label)}
                </label>}
                <Field name={this.props.name} checked={t(this.props.formik.values, this.props.name).safeBoolean}
                    type="checkbox" id={this.props.id} disabled={this.props.disabled}
                />
                <label className="checkbox-label" htmlFor={this.props.id}>
                    <CheckIcon />
                </label>
            </div>
        )
    }
}




BbFormikCheckbox.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    labelClass: PropTypes.string
};

export default connect(BbFormikCheckbox);

